import {
  InMemoryHeader,
  InMemoryString,
} from "pbas-vue-components";

import { translate2 } from '../trans2'
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";


const InMemoryLocalsHeaders = [
   new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name")
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Name"
  }),
  new InMemoryHeader({
    title: "globals.number",
    type: new InMemoryString("Number"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
    version: 1
  }),
  new InMemoryHeader({
    title: "globals.address",
    type: new InMemoryString("Address/City", {
      getString: (item) => {
        var res = "";
        if (item.Address) {
          if (item.Address.SuiteNumber)
            res += item.Address.SuiteNumber;
          if (item.Address.StreetNumber) {
            if (res.length > 0) res += " ";
            res += item.Address.StreetNumber.toString();
          }
          if (item.Address.StreetName) {
            if (res.length > 0) res += ", ";
            res += item.Address.StreetName;
          }
          if (res.length > 0) res += ", ";
          res += item.Address.City + ", " + item.Address.Province.Code;
          if (item.Address.PostalCode) res += " " + item.Address.PostalCode;
        }
        return res;
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    subHeaders: [
      new InMemoryHeader({
        title: "globals.address_street_number",
        type: new InMemoryString("Address/StreetNumber"),
        visible: false,
        allowVisibilityChange: false,
      }),
      new InMemoryHeader({
        title: "globals.address_suite_number",
        type: new InMemoryString("Address/SuiteNumber"),
        visible: false,
        allowVisibilityChange: false,
      }),
      new InMemoryHeader({
        title: "globals.address_street_name",
        type: new InMemoryString("Address/StreetName"),
        visible: false,
        allowVisibilityChange: false,
      }),
      new InMemoryHeader({
        title: "globals.address_province",
        type: new InMemoryString("Address/Province/Code"),
        visible: false,
        allowVisibilityChange: false,
      }),
      new InMemoryHeader({
        title: "globals.address_postal_code",
        type: new InMemoryString("Address/PostalCode"),
        visible: false,
        allowVisibilityChange: false,
      }),
      new InMemoryHeader({
        title: "globals.address_city",
        type: new InMemoryString("Address/City"),
        visible: false,
        allowVisibilityChange: false,
      })
    ]
  }),
  new InMemoryHeader({
    title: "headers.locals.phone_number",
    type: new InMemoryString("PhoneNumber", {
      getString: (item) => {
        console.log(item);
        if (item.PhoneNumber) {
          return masker(item.PhoneNumber, "(###) ### - ####", true, tokens)
        }
        return "";
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.fax_number",
    type: new InMemoryString("Fax", {
      getString: (item) => {
        if (item.Fax) {
          return masker(item.Fax, "(###) ### - ####", true, tokens)
        }
        return "";
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.contacts.email",
    type: new InMemoryString("Email"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.contacts",
    type: new InMemoryString("Contacts[]/Name", {
      getHtml: (item, type) => {
        return ("<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
        item.Contacts.map(o=>o.Name).join(", ") +
          "</div>");
      }
    }),
    sortable: false,
    visible: true,
    searchable: true
  }),
];
export default InMemoryLocalsHeaders;